import { useEffect } from "react";
import { useAuth } from "../../../context/AuthContext/AuthContext";
import BlogCategories from "../components/BlogCategories/BlogCategories";
import FeaturedPosts from "../components/FeaturedPosts/FeaturedPosts";
import PostList from "../components/PostList/PostList";
import "./Homepage.css";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet-async";

const Homepage = () => {
  const { isAdmin } = useAuth();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div
      className="homepage px-8 bg-gray-100 pt-4 flex flex-col gap-4  md:px-8"
      style={{
        minWidth: "12rem",
      }}
    >
      <Helmet>
        <title>GSPEN ბლოგი – კვება, კალორიები და ჯანმრთელობა</title>
        <meta
          name="description"
          content="GSPEN ბლოგი – სტატიები კვებაზე, კალორიების დათვლაზე, დიეტებზე, ცხოვრების ჯანსაღ წესზე და პრაქტიკულ რეკომენდაციებზე."
        />
        <link rel="canonical" href="https://www.gspen.ge/blog" />
      </Helmet>

      <div className="flex gap-4">
        <Link to="/blog" className="text-sm md:text-md">
          ბლოგი
        </Link>
        <span className="text-sm md:text-md">/</span>
        <span className="text-blue-800 text-sm md:text-md">სტატიები</span>
      </div>
      <div className="flex items-center justify-between">
        <div className="">
          <h1 className="text-gray-800 text-3xl md:text-2xl lg:text-3xl font-bold">
            GSPEN ბლოგი
          </h1>
        </div>
        {isAdmin && (
          <Link to="write" className="relative md:block">
            <svg
              viewBox="0 0 200 200"
              width="80"
              height="80"
              className="text-lg tracking-widest animate-spin animated-button"
            >
              <path
                id="circlePath"
                fill="none"
                d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
              />
              <text>
                <textPath href="#circlePath" startOffset="0%">
                  დაპოსტე
                </textPath>
                <textPath href="#circlePath" startOffset="50%">
                  დაპოსტე
                </textPath>
              </text>
            </svg>
            <button className="absolute top-0 left-0 right-0 bottom-0 m-auto w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="50"
                height="50"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <line x1="6" y1="18" x2="18" y2="6" />
                <polyline points="9 6 18 6 18 15" />
              </svg>
            </button>
          </Link>
        )}
      </div>
      <BlogCategories />
      <FeaturedPosts />
      <div className="mt-2">
        <h2 className="text-gray-800 text-xl md:text-2xl font-bold mb-4">
          ბოლო პოსტები
        </h2>
        <PostList />
      </div>
    </div>
  );
};

export default Homepage;
